/**
 * Helpers de formatacao da Fase 5.
 */

export function fmtDias(n) {
  if (n === null || n === undefined) return "—";
  if (n === 0) return "hoje";
  if (n === 1) return "1 dia";
  return `${n} dias`;
}

export function fmtAtraso(n) {
  if (n === null || n === undefined) return "—";
  if (n > 0) return `atrasado ${n}d`;
  if (n === 0) return "vence hoje";
  return `${Math.abs(n)}d folga`;
}

export function atrasoTone(n) {
  if (n === null || n === undefined) return "neutral";
  if (n > 3) return "danger";
  if (n > 0) return "warning";
  if (n === 0) return "warning";
  return "success";
}
